import { StarIcon } from "@heroicons/react/24/outline";
import React from "react";
import boxTestimonial from "../../assets/images/boxTestimonial.webp";
import CustomTitle from "../sharedComponents/customTitle";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ar";
import CustomLines from "../home/customLines";
import CustomBigText from "../sharedComponents/customBigText";

const TestimonialCard = ({ testimonials, isPaid }) => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  dayjs.extend(relativeTime);
  dayjs.locale(direction === "rtl" ? "ar" : "en");
  // console.log(testimonials);
  return (
    <section dir={direction}>
      <div
        className={`relative pt-5 pb-10 max-container ${
          !isPaid ? "md:mt-[3rem] mt-[2.5rem]" : ""
        } `}
      >
        {!isPaid ? (
          <div className="relative z-20 flex flex-col items-center justify-center text-center transition-opacity duration-1000">
            <CustomLines />
            <CustomBigText title={t("CustomerReviews")} />
          </div>
        ) : (
          <CustomTitle title={t("CustomerReviews")} />
        )}
      </div>
      <div className="px-4 pb-10 mx-auto space-y-6 max-container md:px-0">
        {testimonials?.map((testimonial, index) => (
          <div
            key={index}
            className="overflow-hidden bg-white shadow-md"
            style={{ height: "auto" }}
          >
            <div className="flex flex-col h-full border-2 border-gray-300 md:flex-row">
              <div className="flex-shrink-0 md:w-1/5">
                <img
                  src={testimonial?.image ? testimonial?.image : boxTestimonial}
                  alt={testimonial?.name}
                  className="object-cover w-full h-full max-h-[150px] md:max-h-auto"
                />
              </div>

              <div className="flex flex-col justify-between p-6 md:w-4/5">
                <div className="flex items-center gap-3 mb-3">
                  {/* <span className="text-3xl">{testimonial?.flagUrl}</span> */}
                  <img src={testimonial?.flagUrl} alt={testimonial?.name} />
                  <h3 className="text-xl font-bold text-gray-800">
                    {testimonial?.name}
                  </h3>
                </div>

                {/* Comment */}
                <p
                  className="flex-grow mb-3 text-base leading-relaxed text-gray-600"
                  style={{
                    overflow: "hidden",
                    display: "-webkit-box",
                    // WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {direction === "rtl"
                    ? testimonial?.comment_AR
                    : testimonial?.comment_EN}
                </p>

                <div className="flex items-center justify-between">
                  <div className="flex gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span key={star} className="text-xl">
                        {star <= testimonial?.rate ? (
                          <StarIcon
                            key={star}
                            className="w-6 h-6 text-yellow-400 transition-colors duration-200 fill-yellow-400 "
                          />
                        ) : (
                          <StarIcon
                            key={star}
                            className="w-6 h-6 text-gray-300 transition-colors duration-200 fill-gray-300 "
                          />
                        )}
                      </span>
                    ))}
                  </div>

                  <span className="text-sm text-gray-500">
                    {/* {new Date(testimonial?.createdAt).toLocaleDateString()} */}
                    {dayjs(testimonial?.createdAt).fromNow()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
export default TestimonialCard;
